class SpeshSubscriptionCard extends HTMLElement {
  connectedCallback() {
    const data = this.querySelector("[data-subscription-card-data]");
    if (!data) return;

    try {
      this.data = JSON.parse(data.textContent);
      this.variants = this.data.variants || [];
    } catch (error) {
      return;
    }

    this.optionSelects = Array.from(this.querySelectorAll("[data-subscription-option]"));
    this.planSelect = this.querySelector("[data-subscription-plan]");
    this.variantInput = this.querySelector("[data-subscription-variant-id]");
    this.planInput = this.querySelector("[data-subscription-plan-id]");
    this.price = this.querySelector("[data-subscription-price]");
    this.comparePrice = this.querySelector("[data-subscription-compare]");
    this.save = this.querySelector("[data-subscription-save]");
    this.button = this.querySelector('button[name="add"]');
    this.buttonLabel = this.button?.querySelector("span");
    this.unavailableLabel = this.dataset.unavailableLabel || "Unavailable";
    this.availableLabel = this.button?.dataset.availableLabel || "Add subscription";

    this.optionSelects.forEach((select) => select.addEventListener("change", () => this.update()));
    this.planSelect?.addEventListener("change", () => this.update());
    this.update();
  }

  money(cents) {
    const currency = window.Shopify?.currency?.active || "USD";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
        style: "currency",
        currency
      }).format(Number(cents) / 100);
    } catch (error) {
      return `$${(Number(cents) / 100).toFixed(2)}`;
    }
  }

  selectedVariant() {
    const values = this.optionSelects.map((select) => select.value);
    return this.variants.find((variant) => variant.options.every((option, index) => option === values[index]));
  }

  allocationFor(variant, planId) {
    return (variant.selling_plan_allocations || []).find(
      (allocation) => String(allocation.selling_plan_id) === String(planId)
    );
  }

  update() {
    const variant = this.selectedVariant();
    if (!variant || !this.variantInput || !this.planInput || !this.button) return;

    let allocation = this.allocationFor(variant, this.planSelect?.value);
    if (!allocation && variant.selling_plan_allocations?.length) {
      allocation = variant.selling_plan_allocations[0];
      if (this.planSelect) this.planSelect.value = String(allocation.selling_plan_id);
    }

    this.variantInput.value = variant.id;
    this.planInput.value = allocation ? allocation.selling_plan_id : "";

    const available = Boolean(variant.available && allocation);
    this.button.disabled = !available;
    this.button.setAttribute("aria-disabled", String(!available));
    if (this.buttonLabel) this.buttonLabel.textContent = available ? this.availableLabel : this.unavailableLabel;

    const subscriptionPrice = allocation?.price ?? variant.price;
    const comparePrice = variant.price;
    if (this.price) this.price.textContent = this.money(subscriptionPrice);

    if (this.comparePrice) {
      const showCompare = Number(subscriptionPrice) < Number(comparePrice);
      this.comparePrice.hidden = !showCompare;
      this.comparePrice.textContent = showCompare ? this.money(comparePrice) : "";
    }

    if (this.save) {
      const discount = comparePrice > subscriptionPrice
        ? Math.round((1 - Number(subscriptionPrice) / Number(comparePrice)) * 100)
        : 0;
      this.save.textContent = discount ? `Save ${discount}%` : "";
    }
  }
}

if (!customElements.get("spesh-subscription-card")) {
  customElements.define("spesh-subscription-card", SpeshSubscriptionCard);
}
